<div class="card">
  <div class="flex items-center justify-between relative">
    <button
      pButton
      pRipple
      icon="pi pi-arrow-left"
      class="p-button-text text-color p-button-rounded p-button-secondary border-surface-200 dark:border-surface-600"
      (click)="backToDocumentationPage()"
    ></button>
    <div class="w-10"></div>

    <h1 class="text-black text-3xl font-bold text-center flex-grow">
      {{ title }}
    </h1>
  </div>
</div>
